import React from "react";

const OMNISCAN_BLUE = "#20afe8";

export default function StatBox({

    label,

    value,

    date

}) {

    return (

        <div
            style={{

                display:
                    "flex",

                flexDirection:
                    "column",

                justifyContent:
                    "space-between",

                padding:
                    "12px 14px",

                //------------------------------------------------
                // OmniScan Flat
                //------------------------------------------------

                borderRadius:
                    "0px",

                width:
                    "100%",

                boxSizing:
                    "border-box",

                margin:
                    "10px 0 10px 20px",

                background:
                    "rgba(255,255,255,0.025)",

                border:
                    "1px solid rgba(255,255,255,0.08)",

                borderLeft:
                    `3px solid ${OMNISCAN_BLUE}`,

                boxShadow:
                    "0 5px 14px rgba(0,0,0,0.18)"

            }}
        >

            {/* LABEL */}

            <div
                style={{

                    fontSize:
                        "11px",

                    fontWeight:
                        500,

                    color:
                        "rgba(255,255,255,0.50)",

                    letterSpacing:
                        "0.3px"

                }}
            >

                {label}

            </div>

            {/* VALUE */}

            <div
                style={{

                    fontSize:
                        "22px",

                    fontWeight:
                        700,

                    color:
                        "#ffffff"

                }}
            >

                {value}%

            </div>

            {/* DATE */}

            <div
                style={{

                    fontSize:
                        "11px",

                    color:
                        "rgba(255,255,255,0.40)"

                }}
            >

                {date}

            </div>

        </div>

    );

}